import MenuItem from "../../models/MenuItem";

class MenuMapper {

    static toMenuItem(item : any[]) : MenuItem[] {
        
        const result : MenuItem[] = item.map(i => ({
            id: i.id,
            name: i.name,
            description: i.description,
            price: i.price,
            imgUrl: i.img_url
        }));

        return result;
    }
}

export default MenuMapper;